import { render } from "./EditLocation.vue?vue&type=template&id=10f2b074&scoped=true"
import script from "./EditLocation.vue?vue&type=script&lang=js"
export * from "./EditLocation.vue?vue&type=script&lang=js"

import "./EditLocation.vue?vue&type=style&index=0&id=10f2b074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f2b074"]])

export default __exports__